import script from "./TheNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./TheNotifications.vue?vue&type=script&setup=true&lang=js"

import "./TheNotifications.vue?vue&type=style&index=0&id=05cf7597&scoped=true&lang=css"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05cf7597"]])

export default __exports__